import React, { useState, useEffect } from 'react';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Card,
  CardContent,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import { firestore } from '../../firebase';

function ContactTab() {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const messagesRef = firestore.collection('contacts');
        const messagesData = await messagesRef.get();

        const fetchedMessages = [];

        for (const doc of messagesData.docs) {
          const message = doc.data();
          const userId = message.userId;

          // Fetch user information for the current message from the "users" collection
          const userRef = firestore.collection('users').doc(userId);
          const userDoc = await userRef.get();
          const userData = userDoc.data();

          // Add the user information to the message
          fetchedMessages.push({
            id: doc.id,
            subject: message.subject,
            message: message.message,
            userId: userId,
            user: userData, // Add the user information
          });
        }

        setMessages(fetchedMessages);
        setLoading(false);
      } catch (error) {
        // Handle the error appropriately.
        console.error('Error fetching messages:', error);
      }
    };

    fetchMessages();
  }, []);

  return (
    <div>
      {loading ? (
        <div>Chargement...</div>
      ) : isMobile ? (
        // Render cards for mobile
        messages.map((message) => (
          <Card key={message.id}>
            <CardContent>
              <Typography variant="h6">{message.subject}</Typography>
              <Typography variant="body2">{message.message}</Typography>
              <Typography variant="body2">
                {message.user?.firstName} {message.user?.lastName}
              </Typography>
              <Typography variant="body2">Email: {message.user?.email}</Typography>
            </CardContent>
          </Card>
        ))
      ) : (
        // Render a table for the web
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Subject</TableCell>
              <TableCell>Message</TableCell>
              <TableCell>User</TableCell>
              <TableCell>Email</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {messages.map((message) => (
              <TableRow key={message.id}>
                <TableCell>{message.subject}</TableCell>
                <TableCell>{message.message}</TableCell>
                <TableCell>
                  {message.user?.firstName} {message.user?.lastName}
                </TableCell>
                <TableCell>{message.user?.email}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
}

export default ContactTab;
